import { Button, ButtonProps } from '@mui/material'
import { FC } from 'react'

interface ButtonFieldProps extends ButtonProps {
  children?: React.ReactNode
  startIcon?: any
  endIcon?: any
  style?: {
    height: string
    borderRadius: string
    minWidth?: string
    margin?: string
    backgroundColor?: string
    opacity?: number
    border?: string
    fontFamily?: string
    fontSize?: string
    fontStyle?: string
    fontWeight?: number
    lineHeight?: string
    letterSpacing?: string
    background?: string
    color?: string
  }
  name: string
  onClick?: (e?: any) => void
}

const ButtonField: FC<ButtonFieldProps> = ({
  startIcon,
  style,
  name,
  onClick,
  endIcon,
  ...rest
}) => {
  return (
    <Button
      id="basic-button"
      aria-haspopup="true"
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        ...style,
      }}
      {...rest}
    >
      {name}
    </Button>
  )
}

export default ButtonField
